import * as React from 'react'

import { cn } from '@shared/ui/lib/utils'

export interface FieldProps extends React.ComponentPropsWithoutRef<'div'> {
  readonly invalid?: boolean
}

export function Field({
  className,
  invalid = false,
  ...props
}: FieldProps) {
  return (
    <div
      className={cn('grid gap-1.5', className)}
      data-invalid={invalid || undefined}
      data-slot="field"
      {...props}
    />
  )
}

export interface FieldLabelProps extends React.ComponentPropsWithoutRef<'label'> {
  readonly required?: boolean
}

export function FieldLabel({
  children,
  className,
  required = false,
  ...props
}: FieldLabelProps) {
  return (
    <label
      className={cn('text-[13px] font-bold leading-none text-[var(--lms-color-ink-strong)]', className)}
      data-slot="field-label"
      {...props}
    >
      {children}
      {required ? <span aria-hidden="true"> *</span> : null}
    </label>
  )
}

export interface FieldMessageProps extends React.ComponentPropsWithoutRef<'p'> {
  readonly tone?: 'default' | 'error'
}

export function FieldMessage({
  className,
  tone = 'default',
  ...props
}: FieldMessageProps) {
  return (
    <p
      className={cn(
        'm-0 text-[13px] leading-snug',
        tone === 'error' ? 'text-[var(--lms-color-danger)]' : 'text-[var(--lms-color-ink-muted)]',
        className,
      )}
      data-slot="field-message"
      role={tone === 'error' ? 'alert' : undefined}
      {...props}
    />
  )
}
